import React from 'react';
import { Target, Search, Send, CalendarCheck } from 'lucide-react';
import { HUNTR_STEPS } from '@/data/huntr';

const ICONS = { Target, Search, Send, CalendarCheck };

export default function HuntrHow() {
  return (
    <section className="bg-[#0B0B0B] border-t border-white/10 py-16 lg:py-24">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6]">How Huntr Works</p>
        <h2 className="mt-4 font-display font-bold text-white text-3xl lg:text-[2.75rem] tracking-tight max-w-2xl leading-tight">
          Four steps. One autonomous pipeline.
        </h2>
        <p className="mt-4 text-white/55 font-light max-w-2xl leading-relaxed">
          No database filtering, no sequence building, no SDR headcount. You describe the buyer —
          Huntr runs the entire outbound loop under senior strategist supervision.
        </p>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {HUNTR_STEPS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <div
                key={s.title}
                className="group rounded-xl border border-white/10 bg-white/[0.03] p-6 hover:border-[#3B82F6]/50 transition-colors duration-500"
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="w-10 h-10 rounded-lg bg-[#2563EB]/15 flex items-center justify-center">
                    <Icon className="w-4 h-4 text-[#3B82F6]" />
                  </span>
                  <span className="font-display font-bold text-white/15 text-2xl">0{i + 1}</span>
                </div>
                <h3 className="font-display font-semibold text-white text-lg">{s.title}</h3>
                <p className="mt-3 text-sm text-white/50 leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}